
import React from 'react';
import { Paper } from '@/types/paper';
import TexText from '@/components/common/TexText';
import { cn } from '@/lib/utils';

interface PaperCardAbstractProps {
  paper: Paper;
  featured: boolean;
  compact?: boolean;
}

const PaperCardAbstract: React.FC<PaperCardAbstractProps> = ({ paper, featured, compact = false }) => {
  if (!featured) return null;
  
  return (
    <div className={cn('mb-4 overflow-hidden', compact ? 'max-h-[4.5rem]' : 'h-[120px]')}>
      <p className={cn('text-muted-foreground', compact && 'line-clamp-3')}>
        <TexText>{paper.abstract}</TexText>
      </p>
    </div>
  );
};

export default PaperCardAbstract;
